// extracted by mini-css-extract-plugin
module.exports = {"root":"Paper_root__23zkz"};